<template>
  <div
    class="group flex items-center w-full transition duration-100 ease-in-out border rounded focus-within:ring-2 focus-within:ring-blue-500 focus-within:outline-none focus-within:ring-opacity-50"
    :class="classes"
  >
    <div class="flex items-center w-full h-full">
      <textarea
        v-model="_value"
        class="appearance-none bg-transparent w-full outline-none p-3"
        :placeholder="placeholder"
        :disabled="disabled"
        rows="3"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useInput } from '~/composables/input';
import type { Variants, Sizes } from '~/composables/input';

defineOptions({
  name: 'BTextarea'
});

const props = defineProps<{
  modelValue: string | number;
  id?: string;
  placeholder?: string;
  variant?: keyof Variants;
  size?: keyof Sizes;
  flat?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits(['update:modelValue', 'blur', 'focus', 'keyup', 'keydown']);

const _value = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  }
});

const sizes = ref<Sizes>({
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-sm'
})

const { classes, handlers } = useInput(
  {
    variant: props.variant || 'base',
    size: props.size || 'md',
    flat: props.flat || false,
    disabled: props.disabled || false,
    sizes: sizes.value
  },
  emit as (event: string, ...args: any[]) => void
);

</script>
